// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2hfZ-","spin":"Spinner_spin__N2rA8"};